export default function() {
    $('form[name="person"]').hide();
    $('a.edit-name').click(function(e) {
        e.preventDefault();
        $('form[name="person"]').toggle();
        if ($("span.edit-name-text").html() == "edit") {
            $("span.edit-name-text").html("cancel");
        } else {
            $("span.edit-name-text").html("edit");
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/person.js